import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import clickEvent from '@/app/components/search/Curiosity/clickEvent.ts';
import { RouteType } from '@/app/components/search/Curiosity';
import { BannerLink } from '@/app/components/search/components/Banners/ReassuranceBanner/styled.ts';
import { REASSURANCE_MARKETS } from '@/app/components/search/components/Banners/ReassuranceBanner/marketConfig.ts';

const SIZES = '(min-width: 1280px) 1200px, 100vw';

const ReassuranceBanner = () => {
  const { commonData, localization, curiosityParams } = usePageWrapperData();
  const { country, imageBasePath } = localization;
  const market = REASSURANCE_MARKETS[country];

  if (!market) return null;

  const base = `${imageBasePath}banners/${market.lang}/reassurance`;

  const handleClick = () => {
    clickEvent({
      clickParams: { event_name: 'reassurance_banner', event_context: 'banner_cta' },
      routeType: RouteType.OSMAP,
      commonData,
      localization,
      curiosityParams,
    });
  };

  return (
    <BannerLink href={market.href} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
      <picture>
        <source media="(max-width: 767px)" srcSet={`${base}-440.gif 440w, ${base}-440@2x.gif 880w`} sizes="100vw" />
        <img
          src={`${base}-1200.gif`}
          srcSet={`${base}-868.gif 868w, ${base}-1200.gif 1200w, ${base}-868@2x.gif 1736w, ${base}-1200@2x.gif 2400w`}
          sizes={SIZES}
          width={1200}
          height={90}
          alt="lastminute.com Flight + Hotel"
          loading="eager"
        />
      </picture>
    </BannerLink>
  );
};

export default ReassuranceBanner;
